/**
 * Pub/sub contract for the PDF download-options flow.
 *
 * DocumentShow's header Download button dispatches this event. The shared
 * viewer's own toolbar uses its internal download flow directly.
 *
 * DocumentPDFViewer subscribes, scopes the event to the current signed URL,
 * and asks the shared viewer to run its ordinary annotation-aware download.
 *
 * The event fires on `window` for the legacy class-component header; the URL
 * check prevents another mounted file viewer from handling the same request.
 */

export const DOWNLOAD_REQUESTED_EVENT = 'liscio:pdf-download-requested';

/** Payload sent with the {@link DOWNLOAD_REQUESTED_EVENT} CustomEvent. */
export type DownloadRequestedDetail = {
  /** Pre-signed attachment URL for the uploaded PDF. Used when the user
   * chooses "download original" or when the document has no annotations. */
  originalUrl: string;
};
